import Axios from "axios";

const API = Axios.create();
API.interceptors.response.use(
  (response) => {
    let apitime = new Date(localStorage.getItem("API_TIME")) || new Date();

    let dm = sessionStorage.getItem("DOMAIN");
    var endDate = new Date();
    var seconds =
      (endDate.getTime() - (apitime?.getTime() || new Date())) / 1000;
//console.log('end data',endDate,seconds,60*15)
    let rememberme = localStorage.getItem("RememberMe");
// 15 min
    if (60 * 15 < seconds) {
      //showToast'Session expired. Please log in again.','error',enqueueSnackbar)
      if (rememberme == "true") {
        localStorage.removeItem("AUTH_TOKEN");
        localStorage.removeItem("API_TIME");

        if (!window.location.href.includes("/signin")) {
          window.location.replace(`/signin`);
        }
      } else {
        localStorage.clear();
        if (!window.location.href.includes("/signin")) {
          window.location.replace(`/signin`);
        }
      }
    } else {
      localStorage.setItem("API_TIME", new Date());
    }
    return response;
  },
  (error) => {
    // console.error("error", error);

    const { status, message, data } = error.response;
    if (status === 401) {

      if(data){

        setTimeout(() => {
          localStorage.clear();
          if (!window.location.href.includes("/sigin")) {
            window.location.replace(`/signin`);
          }
         }, 3000);
         
         localStorage.setItem("logoutEvent", Date.now());
         window.dispatchEvent(new Event("storage"));
      }

      if(message === "Your account has been deactivated by admin. Please contact your HOS administrator."){
       setTimeout(() => {
        localStorage.clear();
        if (!window.location.href.includes("/sigin")) {
          window.location.replace(`/signin`);
        }
       }, 3000);
       localStorage.setItem("logoutEvent", Date.now());
       window.dispatchEvent(new Event("storage"));
      }else{
        setTimeout(() => {
          localStorage.clear();
          if (!window.location.href.includes("/sigin")) {
            window.location.replace(`/signin`);
          }
         }, 3000);
         localStorage.setItem("logoutEvent", Date.now());
         window.dispatchEvent(new Event("storage"));
      }
    }
    return Promise.reject(error);
  }
);
export default API;
